import { ENV_VARS } from 'ENV_CONFIG';
import cookie from 'jl-my-account/utils/cookie';

export const isFeatureEnabled = (features, featureName) => {
  let cookieName = featureName;

  switch (featureName) {
    case 'jl_brand_promise': {
      cookieName = 'JL_BRAND_PROMISE';
      break;
    }
  }

  const isFeatureEnabled = features.some(
    (feature) =>
      feature.name === `${featureName}_${ENV_VARS.REACT_APP_FEATURES_APP_ENV}` && feature.enabled,
  );
  const cookieOverride = cookie.getCookie(cookieName) === 'true';
  return isFeatureEnabled || cookieOverride;
};
